import { useCallback } from "react";
import { useAsync } from "@/shared/hooks/HookBase";
import ClientIntegrationService from "../services/ClientIntegrationService";
import type UserIntegrationToken from "../models/UserIntegrationToken";

const clientIntegrationService = new ClientIntegrationService();

export function useClientIntegrations() {
  const { loading, error, execute } = useAsync();

  const getMyConnections = useCallback(async (): Promise<
    UserIntegrationToken[] | void
  > => {
    return await execute(() =>
      clientIntegrationService.getMyConnections(),
    );
  }, [execute]);

  const disconnect = useCallback(
    async (providerId: string): Promise<void> => {
      return await execute(
        () => clientIntegrationService.disconnect(providerId),
        { successMessage: "Conexión desvinculada correctamente" },
      );
    },
    [execute],
  );

  const connect = useCallback(
    async (providerId: string, returnUrl: string): Promise<void> => {
      const url = await execute(() =>
        clientIntegrationService.getAuthorizeUrl(providerId, returnUrl),
      );
      if (url) {
        window.location.href = url;
      }
    },
    [execute],
  );

  return {
    loading,
    error,
    getMyConnections,
    disconnect,
    connect,
  };
}
